
import { computed, defineComponent, PropType } from 'vue'
import { AuditLogsSearchFilter } from '@/views/_shared/search-list/types'
import AuditLogsFormFieldSearch from '@/components/audit-logs/form-fields/search.vue'
import AuditLogsFormFieldId from '@/components/audit-logs/form-fields/id.vue'
import AuditLogsFormFieldOperatorName from '@/components/audit-logs/form-fields/operator-name.vue'
import AuditLogsFormFieldOperatorOrigin from '@/components/audit-logs/form-fields/operator-origin.vue'
import AuditLogsFormFieldRequestId from '@/components/audit-logs/form-fields/request-id.vue'
import AuditLogsFormFieldOccurrence from '@/components/audit-logs/form-fields/occurrence.vue'
import AuditLogsFormFieldAction from '@/components/audit-logs/form-fields/action.vue'

export default defineComponent({
    name: 'audit-logs-filter',
    components: {
        AuditLogsFormFieldSearch,
        AuditLogsFormFieldId,
        AuditLogsFormFieldOperatorName,
        AuditLogsFormFieldOperatorOrigin,
        AuditLogsFormFieldRequestId,
        AuditLogsFormFieldOccurrence,
        AuditLogsFormFieldAction
    },
    props: {
        modelValue: {
            type: Object as PropType<AuditLogsSearchFilter>,
            required: true
        }
    },
    async setup (props, { emit }) {
        const localModel = computed({
            get: () => props.modelValue,
            set: value => emit('update:modelValue', value)
        })

        return {
            localModel
        }
    }
})
